import {
  GetPromotionCampaignsRequest,
  CreatePromotionCampaignRequest,
  UpdatePromotionCampaignRequest,
  DeletePromotionCampaignRequest,
  PromotionCampaign,
  PromotionCampaignsApi,
} from '@Generated/back-office-client/src'
import { PromotionCampaignFormData } from '@Components/promotion-campaigns/types'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(PromotionCampaignsApi)

const getPromotionCampaigns = async (): Promise<PromotionCampaign[]> => {
  const request: GetPromotionCampaignsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await getApi().getPromotionCampaigns(request)
}

const createPromotionCampaign = async (
  campaign: PromotionCampaignFormData,
): Promise<PromotionCampaign> => {
  const request: CreatePromotionCampaignRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    backOfficePromotionCampaignCreateRequest: campaign,
  }

  return await getApi().createPromotionCampaign(request)
}

const updatePromotionCampaign = async (
  id: string,
  campaign: PromotionCampaignFormData,
): Promise<PromotionCampaign> => {
  const request: UpdatePromotionCampaignRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    id,
    backOfficePromotionCampaignUpdateRequest: campaign,
  }

  return await getApi().updatePromotionCampaign(request)
}

const deletePromotionCampaign = async (id: string): Promise<void> => {
  const request: DeletePromotionCampaignRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    id,
  }

  return await getApi().deletePromotionCampaign(request)
}

const updatePromotionPriorities = async (
  priorities: Array<{ id: string; priority: number }>,
): Promise<PromotionCampaign[]> => {
  return await getApi().updatePromotionPriorities({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    updatePromotionPrioritiesRequestInner: priorities,
  })
}

export const PromotionCampaignsServiceAPI = {
  getPromotionCampaigns,
  createPromotionCampaign,
  updatePromotionCampaign,
  deletePromotionCampaign,
  updatePromotionPriorities,
}
